<template>
    <el-dialog
        :title="titleText"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose">
        <div class="modal-content" v-loading="dataLoading">
            <el-form label-width="150px">
                <el-form-item label="所选角色：">
                    <span>{{roleName}}</span>
                </el-form-item>
                <el-form-item v-if="platIds.length>0" label="配置媒体：">
                    <span>{{platNames}}</span>
                </el-form-item>
                <el-form-item v-if="isHasPlatCompany" label="媒体账户权限配置：">
                    <div class="mt4">
                        <p v-for="(item,platId) in platCompany" :key="item">
                            <span>{{getPlatName(platId)}}：</span>
                            <span v-if="item=='2'">按照账户绑定与授权</span>
                            <span v-else-if="item=='1'">全部账户</span>
                            <span v-else>--</span>
                        </p>
                    </div>
                </el-form-item>
                <el-form-item v-if="isHasDataDays" label="数据日期权限配置：">
                    <span v-if="data.data_days_type=='2'">分模块配置</span>
                    <span v-else-if="data.data_days_type=='1'&&data.data_days>0">整体配置：最近{{data.data_days}}天</span>
                    <span v-else>整体配置：不限</span>
                </el-form-item>

                <el-form-item label="其他权限：">
                    <el-checkbox :value="data.department_data_permission_tips" disabled true-label="1" false-label="0">部门数据权限内标签维护提示
                        <el-tooltip placement="right">
                            <div slot="content" style="max-width: 300px;">
                                <p class="mb10">影响成员登录时，产品未维护标签信息（如IAA、IAP）时的强提醒。</p>
                                <p class="mb10">* 若勾选，则部门数据权限内的其他成员负责的产品需要提醒时，会给当前角色的成员触发时也提醒。</p>
                                <p>* 组长&上级负责人酌情选中此功能即可。</p>
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </el-checkbox>
                </el-form-item>

                <el-form-item v-if="isHasDimensionType" label="数据维度权限配置：">
                    <div class="mt4">
                        <p v-for="(item,platId) in dimensionType" :key="item">{{getPlatName(platId)}}：{{getDimensionTypeText(platId,item)||'--'}}</p>
                    </div>
                </el-form-item>
                <el-form-item v-if="isHasDataType" label="数据类型权限配置：">
                    <div class="mt4">
                        <p v-for="(item,platId) in dataType" :key="item">{{getPlatName(platId)}}：{{getDataTypeText(platId,item)||'--'}}</p>
                    </div>
                </el-form-item>
                <el-form-item v-if="isHasActions" label="页面与操作权限配置1：">
                    <div class="mt6">
                        <RoleConfigCard :config="operationConfig" :tag-action-ids-editable="tagActionIdsEditable" :action-ids="actionIds" :sub-data-days="data.sub_data_days||{}" :role-action="roleAction" />
                    </div>
                </el-form-item>
                <el-form-item v-if="isHasSpecialConfig" label="组织架构管理：">
                    <div class="">
                        配置可选角色：{{getRoleNames(optionalRole)}}
                    </div>
                </el-form-item>
                <el-form-item v-if="isHasSpecialOptionalTable" label="配置管理页面：">
                    <div class="">
                        可查看配置表：{{getOptionalTableNames(optionalTable)}}
                    </div>
                </el-form-item>
            </el-form>

            <!--<div>{{JSON.stringify(data)}}</div>-->
        </div>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="primary" @click="hideModal">关闭</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import API from '@/api/role.js';
    import RoleConfigCard from '../components/roleConfigCard';

    export default {
        name: "BatchRoleInfoModal",
        props:{
            data:Object,
            name:String,
        },
        components:{
            RoleConfigCard,
        },
        data(){
            return {
                dialogVisible:false,
                dataLoading:false,

                dataTypeConfig: {},      // 2-广告投放数据 3-财务数据
                dimensionTypeConfig: {},      // 维度权限配置
                platCompanyConfig: {},   // 1-全部账户 2-按照客户管理绑定
                platConfig: [],      // 1-OPPO 3-vivo 4-华为 7-mi 8-爱奇艺 9-Apple
                operationConfig: [],     // 页面与操作权限配置
                roleList:[],
                optionalTableList:[],
            }
        },
        computed:{
            roleName(){
                let rowList = this.data.role_list||[];
                return rowList.map(item=>item.role_name).join('、');
            },
            titleText(){
                return '批量'+(this.data.type=='1'?'增加权限':'去除权限');
            },
            platIds(){
                return this.data.plat_ids||[];
            },
            platNames(){
                return this.platIds.map(item=>{
                    let platItem = this.platConfig.find(inner=>inner.id==item)||{};
                    return platItem.name||'';
                }).join('、');
            },
            isHasPlatCompany(){
                return Object.values(this.data.plat_company||{}).length>0;
            },
            platCompany(){
                return this.data.plat_company||{};
            },
            isHasDataDays(){
                return this.data.data_days||this.data.data_days_type;
            },
            isHasDimensionType(){
                return Object.values(this.data.dimension_type ||{}).length>0;
            },
            dimensionType(){
                return this.data.dimension_type ||{};
            },
            isHasDataType(){
                return Object.values(this.data.data_type ||{}).length>0;
            },
            dataType(){
                return this.data.data_type ||{};
            },
            isHasActions(){
                let specialConfig = this.data.special_config||{};
                let tagEditable = specialConfig.tag_action_ids_editable||{};

                return (this.data.action_ids ||[]).length>0||this.data.data_days_type=='2'||Object.values(tagEditable).length>0;
            },
            isHasSpecialOptionalTable(){
                let special_config = this.data.special_config ||{};
                let optional_role = special_config.optional_role||"";
                return optional_role.length>0;
            },
            isHasSpecialConfig(){
                let special_config = this.data.special_config ||{};
                let optional_config_table = special_config.optional_config_table||"";
                return optional_config_table.length>0;
            },
            optionalTable(){
                let special_config = this.data.special_config ||{};
                return special_config.optional_config_table||"";
            },
            optionalRole(){
                let special_config = this.data.special_config ||{};
                return special_config.optional_role||"";
            },
            tagActionIdsEditable(){
                let special_config = this.data.special_config ||{};
                let tags = special_config.tag_action_ids_editable;
                if(Array.isArray(tags)&&tags.length<=0){
                    return {};
                }else{
                    return tags||{}
                }
            },
            actionIds(){
                return this.data.action_ids ||[];
            },
            roleAction(){
                if(Array.isArray(this.data.role_action)&&this.data.role_action.length<=0) return {};
                return this.data.role_action ||{};
            },

        },
        methods:{
            handleClose(done){
                console.log('handleClose',done);
                this.dialogVisible = false;
            },
            showModal(){
                this.dialogVisible = true;
                console.log(this.name,this.data);
                this.dataLoading = true;
                this.getConfig();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close',this.modalData);
            },
            getConfig(){
                API.getAddRoleConfig().then(res => {
                    let resData = res.data || {};
                    let permConfig = resData.data_config.perm_config||[];
                    permConfig.forEach(item=>{
                        this.platCompanyConfig[item.plat_id] = (item.plat_company_config||[]).sort((a,b)=>b.id-a.id);
                        this.dataTypeConfig[item.plat_id] = item.data_type_config||[];
                        this.dimensionTypeConfig[item.plat_id] = item.dimension_type_config||[];
                    });
                    this.platConfig = resData.data_config.plat_config || [];
                    this.operationConfig = resData.operation_config || [];
                    this.roleList = resData.role_list||[];
                    this.optionalTableList = resData.optional_config_table ||[];

                    this.dataLoading = false;
                }, (err) => {
                    console.log('getConfig error', err);
                    this.dataTypeConfig = {};
                    this.dimensionTypeConfig = {};
                    this.platCompanyConfig = {};
                    this.platConfig = [];
                    this.operationConfig = [];
                    this.dataLoading = false;
                });
            },
            getPlatName(id){
                let platItem = this.platConfig.find(inner=>inner.id==id)||{};
                return platItem.name||'--';
            },
            getDimensionTypeText(platId,listStr){
                return listStr.split(',').map(item=>{
                    let actionItem = (this.dimensionTypeConfig[platId]||[]).find(inner=>inner.id==item)||{};
                    return actionItem.display_type_name||'';
                }).filter(item=>!!item).join('、');
            },
            getDataTypeText(platId,listStr){
                return listStr.split(',').map(item=>{
                    let actionItem = (this.dataTypeConfig[platId]||[]).find(inner=>inner.id==item)||{};
                    return actionItem.display_type_name||'';
                }).filter(item=>!!item).join('、');
            },
            getRoleNames(listStr){
                let list = (listStr||'').split(',');
                console.log('getRoleNames',list,this.roleList);
                return list.map(item=>{
                    let roleItem = this.roleList.find(inner=>inner.role_id==item)||{};
                    return roleItem.role_name||"";
                }).filter(item=>!!item).join('、');
            },
            getOptionalTableNames(listStr){
                let list = (listStr||'').split(',');
                console.log('getOptionalTableNames',list,this.roleList);
                return list.map(item=>{
                    let roleItem = this.optionalTableList.find(inner=>inner.id==item)||{};
                    return roleItem.display_name ||"";
                }).filter(item=>!!item).join('、');
            },
        }
    }
</script>

<style lang="scss" scoped>
    .modal-content{
        padding: 0 20px;
        max-height: 360px;
        overflow-y: auto;

        ::v-deep .el-form-item__label{
            font-weight: bold;
        }
        ::v-deep .el-form-item__content{
            font-size: 12px;
        }
    }
</style>
